(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["misofest-product-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('miso-offer-countdown')) {
    customElements.define('miso-offer-countdown', class extends HTMLElement {
      connectedCallback() {
        this.endAt = Date.parse(this.dataset.end);
        this.clock = this.querySelector('[data-clock]');
        this.units = (this.dataset.units || '').split(',').map(unit => unit.trim());
        if (!Number.isFinite(this.endAt) || !this.clock) {
          this.hidden = true;
          return;
        }
        clearInterval(this.interval);
        if (this.tick()) this.interval = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
      tick() {
        const remaining = Math.max(0, Math.floor((this.endAt - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        this.clock.textContent = values.map((value, i) => String(value).padStart(2, '0') + (this.units[i] || '')).join('  ');
        if (remaining === 0) {
          clearInterval(this.interval);
          if (this.dataset.hideExpired === 'true') {
            const offer = this.closest('[data-misofest-offer]');
            if (offer) offer.hidden = true;
          }
          return false;
        }
        return true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
